import { useContext } from 'react'
import DialogContext from 'app/contexts/DialogContext'

const useDialog = () => useContext(DialogContext)

export default useDialog
